import React from 'react';
import TinyMttStats from 'views/tiny/TinyMttStats.js';

function TinyMttStatsContainer() {
  return <TinyMttStats />;
}

export default TinyMttStatsContainer;
